import { render, staticRenderFns } from "./event-form.vue?vue&type=template&id=1b299e84&scoped=true&"
import script from "./event-form.vue?vue&type=script&lang=js&"
export * from "./event-form.vue?vue&type=script&lang=js&"
import style0 from "./event-form.vue?vue&type=style&index=0&id=1b299e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b299e84",
  null
  
)

export default component.exports